import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  background-color: #f8f8f8; /* Light grey background */
  font-family: Arial, sans-serif;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 80px; /* Space between text and illustration */
  max-width: 1200px;
  padding: 20px;
`;

export const TextContent = styled.div`
  text-align: left;
`;

export const ErrorCode = styled.h1`
  font-size: 120px;
  color: #333;
  margin-bottom: 10px;
`;

export const AccessForbidden = styled.h2`
  font-size: 36px;
  color: #555;
  margin-bottom: 20px;
`;

export const Description = styled.p`
  font-size: 20px;
  color: #777;
  line-height: 1.5;
  margin-bottom: 40px;
`;

export const GoToDashboardButton = styled.button`
  background-color: #419e92;
  color: white;
  padding: 15px 30px;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #419e99;
  }
`;

export const IllustrationContainer = styled.div`
  position: relative;
  width: 300px; /* Adjust as needed */
  height: 400px; /* Adjust as needed */
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const Arch = styled.div`
  width: 200px;
  height: 300px;
  background-color: #1e4c8a;
  border-radius: 100px 100px 0 0;
  position: relative;
  overflow: hidden; /* To contain the eyes */

  &::before {
    content: '';
    position: absolute;
    top: 80px; /* Position the eyes */
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 30px;
    background-color: #222; /* Dark color for the eye area */
    border-radius: 15px;
    mask-image: radial-gradient(circle at 25% 50%, transparent 5px, black 5px),
      radial-gradient(circle at 75% 50%, transparent 5px, black 5px);
    mask-size: 50% 100%;
    mask-repeat: no-repeat;
    mask-position: 0 0, 100% 0;
  }
`;

export const GroundLine = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #bbb; /* Grey line */
`;

export const Barrier = styled.div`
  position: absolute;
  bottom: 80px; /* Position above the ground line */
  width: 250px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BarrierPost = styled.div`
  width: 20px;
  height: 80px;
  background-color: #ccc;
  border-radius: 5px;
`;

export const BarrierTape = styled.div`
  flex-grow: 1;
  height: 40px;
  background-color: #f7e07a; /* Yellow tape */
  border: 2px solid #e0c850;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  color: #333;
  letter-spacing: 1px;
  text-transform: uppercase;
  overflow: hidden;
  position: relative;

  span {
    animation: scrollTape 5s linear infinite;
    white-space: nowrap;
    position: relative;
  }

  @keyframes scrollTape {
    0% {
      transform: translateX(100%);
    }
    50% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

export const Grass = styled.div`
  position: absolute;
  bottom: 0;
  left: 15%;
  width: 50px;
  height: 20px;
  background-color: #8bc34a; /* Green for grass */
  border-radius: 50%;
  transform: rotate(-10deg);
  z-index: 1; /* Above the ground line */
`;
